import React from 'react';

const Loader = () => {
  return (
    <React.Fragment>
      <div className="flex items-center justify-center">
        <div className="text-center mx-4">
          <div className="flex items-center justify-center mb-3">
            <img src="/images/spinnerGreenBgNone.gif" className="w-6 h-6" />
          </div>
          <div className="text-regular text-gray-gray700 font-interLight">
            Mohon tunggu sebentar, kami sedang memproses permintaan kamu
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Loader;
